export default __webpack_public_path__ + "static/media/closer-flowerchick.4a7bf7d0.txt";